import {
  Switch as MUISwitch,
  FormControlLabel,
  useTheme,
  FormGroup,
  FormControl,
} from "@mui/material";
import React from "react";
import Typography from "../typography";

export interface SwitchProps {
  label?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  color?: "primary" | "secondary" | "success" | "error" | "info" | "warning";
  disabled?: boolean;
}

const Switch: React.FC<SwitchProps> = ({
  label = "",
  checked,
  onChange,
  color = "primary",
  disabled = false,
}) => {
  const theme = useTheme();

  return (
    <div>
      <FormControl component="fieldset">
        <FormGroup aria-label="position" row>
          <FormControlLabel
            disabled={disabled}
            control={
              <MUISwitch
                checked={checked}
                onChange={(e) => onChange(e.target.checked)}
                color={color}
                sx={{ transform: "scale(1.2)" }}
              />
            }
            label={
              <Typography
                variant="h3"
                style={{
                  fontWeight: "bold",
                  marginBottom: theme.spacing(-0.5),
                  marginLeft: theme.spacing(1),
                }}
              >
                {label}
              </Typography>
            }
            labelPlacement="top"
            sx={{ alignItems: "flex-start" }}
          />
        </FormGroup>
      </FormControl>
    </div>
  );
};

export default Switch;

/* Use case
  const [showTextFelids, setShowTextFelids] = React.useState(false);

  <Switch
    checked={showTextFelids}
    label="LEASE this bitch"
    onChange={setShowTextFelids}
    isSelected={false}
  />

*/
